export default {
  // 页面标题
  title: '组织（公司）信息',
  
  // 侧边栏导航项
  navigation: {
    billingAndPayments: '账单与支付',
    plan: '方案',
    couponCode: '优惠码',
    timezone: '时区',
    developer: '开发者'
  },
  
  // 权限相关消息
  permissions: {
    tenantUpgradeRequired: '此页面需要租户升级。',
    adminOnly: '仅管理员可访问此内容。'
  },
  
  // 页面描述
  description: '管理组织的设置与偏好'
};
